export const CommentAPI = {};

const SLICE = 'comment';


CommentAPI.create = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/comment`,
    method:   'POST',
    data:     data,
    slice:     SLICE,
    action:    'create',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

CommentAPI.delete = (id, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/comment`,
    method:    'DELETE',
    data:      id,
    slice:     SLICE,
    action:    'delete',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

CommentAPI.update = (data, onSuccess, onFailure) => {
  return {
    type:     'API',
    url:      `/stream/comment`,
    method:   'PUT',
    data:     data,
    slice:     SLICE,
    action:    'update',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};

CommentAPI.list = (data, onSuccess, onFailure) => {
  return {
    type:      'API',
    url:       `/stream/comments`,
    method:    'GET',
    data:      data,
    slice:     SLICE,
    action:    'list',
    onSuccess: onSuccess,
    onFailure: onFailure,
  };
};


